import {onCLS, onINP, onLCP, onTTFB} from 'web-vitals';
(async()=>{
    let metrics = {};
    let stream;
    let streamMasterKey;
    let steamChildKey;
    let webVitals = {};
    let sourceMicroData;
    let eventListnerDataTrigger=false ;
    let pendingEvents = [];
    let isBusy = false;
    let isDebug = false;
    let isTSMInitialized = false;
    const getSourceJSON = async()=>{

        let dataJSONDom = document.querySelector('script[id="agEvent"]');

        let dataJSON = JSON.parse(dataJSONDom.textContent);

        return dataJSON;

    };    

    const setWebVitals=({name,delta,value,id})=>{        
        webVitals[name]=value;
    }    

    onCLS(setWebVitals);
    onINP(setWebVitals);
    onLCP(setWebVitals);
    onTTFB(setWebVitals);

    let log = window.location.host.indexOf('localhost')>-1?console.log:(logs)=>{};
    isDebug = isDebug || window.location.host.indexOf('localhost')>-1;

    const getStream = ()=>{
        return new Promise((resolve,reject)=>{            
            if (stream&&stream.readyState == WebSocket.OPEN)
            {
                resolve(stream);                
            }
            else
            {
                stream = new WebSocket('wss://event-service.idcrealestate.com/ws/track-event');
                stream.onopen = () => {
                    resolve(stream);                    
                };
                stream.onmessage = (e) => {
                    updateStreamMasterKey(e.data);
                };
            
                stream.onclose = () => {
                    stream = undefined;
                };
            
                stream.onerror = (error) => {
                    reject(error);
                };
            }           
        });
    };
    const getStreamMasterKey = ()=>{
        if(localStorage.getItem('AGSTREAM')!=null&&localStorage.getItem('AGSTREAM')!=''){
            return localStorage.getItem('AGSTREAM');
        }
        return null;
    };

    const getUserJSON = ()=>{
        if (window.localStorage.getItem('AGUSER') != null) {
            let current = JSON.parse(window.localStorage.getItem('AGUSER'))
            return {'userGuid':current.Guid};
        }
        return {};
    };

    const updateStreamMasterKey = (data)=>{
        if(!data || data==null||data=='')return;
        let eventJSON = getEventJsonConverter(data);     
        let localStreamKey = getStreamMasterKey();           
        if(eventJSON && eventJSON!=null && eventJSON.UID && (localStreamKey==null||atob(localStreamKey)!=eventJSON.UID))
        {
            streamMasterKey = btoa(eventJSON.UID);
            localStorage.setItem('AGSTREAM',streamMasterKey);
            sendEventStreamKey();
        }
        else if(eventJSON && eventJSON!=null && eventJSON.UID && (atob(localStreamKey)==eventJSON.UID)){
            streamMasterKey = localStreamKey;
            sendEventStreamKey();
        }        
        if(!eventListnerDataTrigger) bindEventActions(eventJSON);
         
    };  
    
    const sendEventStreamKey = async()=>{
        if(streamMasterKey&&streamMasterKey!=null)
            window.dispatchEvent(new CustomEvent('ag.event.stream',{detail:{streamKey:streamMasterKey}}));     
    };
    const getEventJsonConverter = (data) => {
        let jsonData = JSON.parse(data.replace(/(\r\n|\n|\r)/gm, '')); 
    
        if(jsonData.Events)
            jsonData.Events.forEach(item => {
                const actionResultBody = item.ActionResult.replace(/^function\(e\)\s?{/, '').replace(/}$/, '').trim();
                item.ActionResult = new Function('e','callback',`item='${item.EventLabel}'` ,`${actionResultBody}`);
                
            });
        return jsonData;
    }
    const bindEventActions = async (data) => {
        data.Events.forEach(item => {
            if (typeof item.ActionResult === 'function') {
                const eventHandler = (event) => {
                    const selectorElement = event.target.closest(item.Selector);
                    if (selectorElement) {
                        item.ActionResult(event, (data) => {
                            sendEvent(item.EventType,Object.assign(data,sourceMicroData));
                        });
                    }
                };
                document.body.addEventListener(item.EventType, eventHandler);
                eventListnerDataTrigger=true;
            }
        });
    };  
    const sendToStream = async(data)=>{      
        log(data) ;
        if(!isDebug)
        {
            let steamActive = await getStream();       
            steamActive.send(JSON.stringify(data));
        }        
    };

    const sendEvent = async(eventLabel,data)=>{       
        if(isBusy)
        {
            pendingEvents.push({eventLabel:eventLabel,data:data}); 
            return;
        }      
        isBusy=true;
        if(!data)data={};        
        let sourceParams = await getSourceParams();
        let dataPayload = Object.assign(data,sourceParams);        
        await sendToStream({
            eventname: eventLabel.replace(/[^A-z0-9]/gi,'').toLowerCase(),
            eventlabel: eventLabel,
            info:Object.assign({host:dataPayload.host,rawUrl:dataPayload.rawUrl},{additionaljson:dataPayload}),
            client: sourceMicroData.client
        });
        isBusy=false;
        clearEvents();
    };

    const clearEvents =async()=>{
        if(pendingEvents.length>0)
        {
            let dataToSend = pendingEvents.pop();
            await sendEvent(dataToSend.eventLabel,dataToSend.data);
            clearEvents();
        }
    };
    const getSourceParams = async()=>{     
        let sourceMicroDataForParams = await getSourceMicroData();          
        let sourceParams = {
            host: window.location.host.toString().toLowerCase(),
            rawUrl: window.location.pathname.toString().toLowerCase(),
            type: sourceMicroDataForParams?.type,
            uacValue: getUserActivityScore(),
            score:getTSMScore(),
            tsmId:getTSMID(),
            delta:Math.round(performance.now())
        };

        sourceParams = Object.assign(sourceParams,getUserJSON());

        return sourceParams;
    };  

    const getUserActivityScore = ()=>{
        let scoreKey = 'AGSTREAMSCORE';
        if(localStorage.getItem(scoreKey))
        {
            let values = JSON.parse(localStorage.getItem(scoreKey));
            return values.reduce((result,current)=>{
                return result+current;
            },0);
        }
        return 0;
    };

    const getTSMScore = ()=>{
        let currentValue = getTSM();
        if(currentValue.readings&&currentValue.readings.length>0)
        {            
            return Math.floor(currentValue.readings.reduce((result,current)=>{
                return result+current;
            },0)/currentValue.readings.length);
        }
        return 0;
    };

    const tsmKey = 'AGTMSSCORE';

    const getTSM = ()=>{
        let currentValue = localStorage.getItem(tsmKey);
        if(currentValue!=null)
        {
            return JSON.parse(currentValue);            
        }
        return {};
    };

    const setTSM = (tsmValue)=>{
        localStorage.setItem(tsmKey, JSON.stringify(tsmValue));
    };

    const writeScoreToTSM = (score)=>{
        let tsmValues = getTSM();
        if(!tsmValues.readings) tsmValues.readings = [];
        if(!isTSMInitialized)
        {
            tsmValues.readings.push(score);
            isTSMInitialized = true;
            if(tsmValues.readings.length>5)
                tsmValues.readings.splice(0,tsmValues.readings.length-5);
        }
        else tsmValues.readings[tsmValues.readings.length-1]=score;
        
        setTSM(tsmValues);
    }

    const getTSMID = ()=>{
        let scoreKey = 'TSM';
        if(localStorage.getItem(scoreKey)!=null)
        {
            let values = JSON.parse(localStorage.getItem(scoreKey));
            if(values.id)return values.id;
            if(values.uid)return values.uid;
        }
        return 'UA';
    };


    let tsmUserActivityScoreCumulator = (update)=>{
        let movements = [];
        let lastPos = null;
        let lastTime = null;
        let suspectScoreDetected = 0;

        let recordMovement = (x, y) => {
            const now = Date.now();
            if (lastPos && lastTime) {
                const dx = x - lastPos.x;
                const dy = y - lastPos.y;
                const dt = now - lastTime;
                const distance = Math.sqrt(dx * dx + dy * dy);
                const velocity = distance / dt;
                movements.push({ dx, dy, dt, velocity });
                if(movements.length>100)movements.shift();
            }
            lastPos = { x, y };
            lastTime = now;
        }

        let huristicAdaption = (points) => {
            let totalDx = 0, totalDy = 0, totalDt = 0;
            let totalDist = 0;
            let velocities = [];
            points.forEach(p => {
                totalDx += p.dx;
                totalDy += p.dy;
                totalDt += p.dt;
                let dist = Math.sqrt(p.dx * p.dx + p.dy * p.dy);
                totalDist += dist;
                velocities.push(dist / (p.dt || 1e-5)); // avoid divide by zero
            });
            // Feature extraction
            let avgVel = velocities.length ? velocities.reduce((a, b) => a + b, 0) / velocities.length : 0;
            let direction = Math.atan2(totalDy, totalDx); // angle in radians, -π to π

            // Non-linear scaling and normalization
            // velocity: [0, max], direction: [-π, π], totalDist: scale as you wish
            let r = Math.round(255 * Math.min(1, avgVel / 5)); // scale velocity, or use other non-linear (logistic, sqrt, etc)
            let g = Math.round(255 * (direction + Math.PI) / (2 * Math.PI)); // normalize angle to [0,1]
            let b = Math.round(255 * Math.min(1, totalDist / 100)); // scale total distance, or another feature

            return [r, g, b];
        }


        let rgbToGrayWight = (r, g, b) => {
            const gray = 0.299 * r + 0.587 * g + 0.114 * b;  // Accurate grayscale
            return Math.round(gray / 255 * 100);  // Scale to 0-100
        }

        let onRecord = () => {
            document.addEventListener("mousemove", e => recordMovement(e.clientX, e.clientY));
            document.addEventListener("mousedown", e => recordMovement(e.clientX, e.clientY));
            document.addEventListener("touchstart", e => {
                const t = e.touches[0];
                if(t && t.clientX)
                recordMovement(t.clientX, t.clientY);
            });

            document.addEventListener("touchend", e => {
                const t = e.touches[0];
                if(t && t.clientX)
                recordMovement(t.clientX, t.clientY);
            });

            document.addEventListener("touchmove", e => {
                const t = e.touches[0];
                if(t && t.clientX)
                recordMovement(t.clientX, t.clientY);
            });

            document.addEventListener("scroll", e=>{        
                recordMovement(window.scrollX, window.scrollY);
            });
        }

        onRecord();

        if(typeof update==='function')
            update(()=>{
                let rgb = suspectScoreDetected==0?huristicAdaption(movements):[0,0,0];
                let score = suspectScoreDetected==0?rgbToGrayWight(rgb[0],rgb[1],rgb[2]):-1;
                return score;
            });
    }
    

    let userActivityScoreCumulator = ()=>{
        let uasState = {
            events: {},
            counts: {},
            values: {}
        };
        var __uasScore = {};
        var throttling = 10;
        let update = (type, score) => {
            __uasScore[type] = score;
            setScoreStorage(btoa(JSON.stringify(__uasScore)));
        }

        let setScoreStorage = (uasValue) => {
            let scoreKey = 'AGSTREAMSCORE';
            let parameters = JSON.parse(atob(uasValue));
            let calculatedScore = computeScore(parameters);            
            let scoreBoard = localStorage.getItem(scoreKey)?JSON.parse(localStorage.getItem(scoreKey)):[];
            if(scoreBoard.length>5);
                scoreBoard=scoreBoard.splice(scoreBoard.length-1,1);
            scoreBoard.push(calculatedScore);
            localStorage.setItem(scoreKey, JSON.stringify(scoreBoard));            
        }
        let computeScore = (parameters) => {
            let score = 0;
            for (let key in parameters) {
                if (parameters.hasOwnProperty(key)) {
                    // Pass both the key and its value to computeScoreForParam
                    score += computeScoreForParam(key, parameters[key]);
                }
            }
            return score;
        }
        let computeScoreForParam = (key, value) => {
            return value * getComputingConstantsForParams(key);
        }
        let getComputingConstantsForParams = (type) => {
            switch (type.toLowerCase()) {
                case "automation":
                    return -1000;
                case "window":
                case "scroll":
                case "keydown":
                case "touchmove":
                case "mousemove":
                    return 5;
                case "click":
                    return 10;
                default:
                    return 1;
            }
        }
        let addEvent = (type, paramEvent, selector) => {
            let execute = (e) => {
                selector.removeEventListener(paramEvent.e, execute);
                update(type, getEventScore(type, uasState.counts[type], e, paramEvent.g, throttling));
                if (typeof (uasState.counts[type]) != 'undefined' && uasState.counts[type] < throttling) {
                    setTimeout(() => {
                        selector.addEventListener(paramEvent.e, execute);
                    }, paramEvent.t * 1000);
                    uasState.counts[type]++;
                }
            }
            return selector.addEventListener(paramEvent.e ? paramEvent.e : paramEvent.w, execute);
        }
        let getEventScore = (type, f, e, grade, sampleSize) => {
            let currentValue = __uasScore[type] ? __uasScore[type] : 0;
            if (e.type == 'keyboard') return e.keycode.indexOf('Arrow') > -1 ? 0.1 : 1;
            if (e.type == 'scroll') return currentValue < ((document.documentElement.scrollTop || document.body.scrollTop) / document.body.scrollHeight) * grade ? ((document.documentElement.scrollTop || document.body.scrollTop) / document.body.scrollHeight) * grade : currentValue;
            if (e.type == 'click') return currentValue += (/input|select|a|button/gi.test(e.target.nodeName) ? 1 : 0.1) * grade / sampleSize;
            return f * grade / sampleSize;
        }
        let uasEvents = [{ tn: 'window', w: 'focus', c: function () { return document.hasFocus() }, g: 10, t: 2 }, { tn: 'window', w: 'blur', g: 10, t: 2 }, { e: 'scroll', g: 10, t: .2 }, { e: 'mousemove', g: 10, t: .2 }, { e: 'click', g: 10, t: .2 }, { e: 'mousemove', g: 10, t: .2 }, { e: 'keydown', g: 10, t: 1 }, { e: 'touchmove', g: 10, t: 1 }, {
            tn: 'automation',
            c: function () {
                var l1 = ["__webdriver_evaluate", "__selenium_evaluate", "__webdriver_script_function", "__webdriver_script_func", "__webdriver_script_fn", "__fxdriver_evaluate", "__driver_unwrapped", "__webdriver_unwrapped", "__driver_evaluate", "__selenium_unwrapped", "__fxdriver_unwrapped"];
                var l2 = ["_phantom", "__nightmare", "_selenium", "callPhantom", "callSelenium", "_Selenium_IDE_Recorder"];
                var l4 = ["selenium", "webdriver", "driver"];
                for (var l2key in l2) if (window[l2[l2key]]) return true;
                for (var l1key in l1) if (window['document'][l1[l1key]]) return true;
                for (var l3key in window['document']) if (l3key.match(/\$[a-z]dc_/) && window['document'][l3key]['cache_']) return true;
                if (window['external'] && window['external'].toString() && (window['external'].toString()['indexOf']('Sequentum') != -1)) return true;
                for (var l4key in l4) if (window['document']['documentElement']['getAttribute'](l4[l4key])) return true;
                return false;
            }, g: 10, t: 0
        }];
        for (let paramEventKey in uasEvents) {
            let paramEvent = uasEvents[paramEventKey];
            let paramName = paramEvent.tn ? paramEvent.tn : (paramEvent.e ? paramEvent.e : paramEvent.w);
            if (paramEvent.e || paramEvent.w) {
                uasState.events[paramName] = addEvent(paramName, paramEvent, paramEvent.e ? document : window);
                uasState.counts[paramName] = 0;
            }
            if (paramEvent.c && typeof (paramEvent.c) == 'function') {
                if (paramEvent.c()) update(paramName, paramEvent.g);
            }
        }
    };

    const getSourceMicroData = async()=>{
        sourceMicroData = await getSourceJSON();
        return sourceMicroData;
    };

    const autoUpdateTSMScore = (isManual)=>{
        writeScoreToTSM(tsmScoreUpdates());
        if(!isManual)
            setTimeout(() => {
                autoUpdateTSMScore();
            }, 5000);
    };

    userActivityScoreCumulator();   
    let tsmScoreUpdates = ()=>{ return 0; }; 
    tsmUserActivityScoreCumulator((update)=>{
        tsmScoreUpdates = update;
    });
    if(document.readyState!='loading')sendEvent('PageLoad', await getSourceMicroData());
    else document.addEventListener('DOMContentLoaded',async()=>{ sendEvent('PageLoad',await getSourceMicroData());
     });   

     
    window.addEventListener('beforeunload',()=>{ autoUpdateTSMScore(true); sendEvent('PageUnload',webVitals); });
    document.addEventListener("visibilitychange", () => {
      if (document.visibilityState === "hidden") {
        autoUpdateTSMScore(true); sendEvent('PageUnload',webVitals);
      }
    });  
    autoUpdateTSMScore();
    window.addEventListener('ag.event.stream.update',(e)=>{ sendEventStreamKey(); });
    window.agEvent = {
        push:(type,data)=>{ sendEvent(type,data); }
    };            
})();